import _defineProperty from "/home/runner/work/documentation/documentation/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import styled, { css } from 'styled-components';
import PropTypes from 'prop-types';
import theme from './theme';
import { BORDER, COMMON, get, TYPOGRAPHY } from './constants';
import sx from './sx';
var Header = styled.div.withConfig({
  displayName: "Header",
  componentId: "sc-217i47-0"
})(["z-index:32;display:flex;padding:", ";font-size:", ";line-height:", ";color:", ";background-color:", ";align-items:center;flex-wrap:nowrap;", " ", " ", ";"], get('space.3'), get('fontSizes.1'), get('lineHeights.default'), get('colors.whitefade70'), get('colors.bg.grayDark'), COMMON, BORDER, sx);
var HeaderItem = styled.div.withConfig({
  displayName: "Header__HeaderItem",
  componentId: "sc-217i47-1"
})(["display:flex;margin-right:", ";align-self:stretch;align-items:center;flex-wrap:nowrap;", ";", ";", ";", ";"], get('space.3'), function (_ref) {
  var full = _ref.full;
  return full && css(["flex:auto;"]);
}, COMMON, BORDER, sx);
HeaderItem.displayName = 'Header.Item';
var HeaderLink = styled.a.attrs(function (_ref2) {
  var to = _ref2.to;
  var isReactRouter = typeof to === 'string';
  if (isReactRouter) {
    // according to their docs, NavLink supports aria-current:
    // https://reacttraining.com/react-router/web/api/NavLink/aria-current-string
    return {
      'aria-current': 'page'
    };
  } else {
    return {};
  }
}).withConfig({
  displayName: "Header__HeaderLink",
  componentId: "sc-217i47-2"
})(["font-weight:", ";color:", ";white-space:nowrap;cursor:pointer;text-decoration:none;display:flex;align-items:center;&:hover,&:focus{color:", ";}", ";", ";", ";", ";"], get('fontWeights.bold'), get('colors.text.white'), get('colors.whitefade70'), COMMON, BORDER, TYPOGRAPHY, sx);
HeaderLink.displayName = 'Header.Link';
Header.propTypes = _objectSpread(_objectSpread(_objectSpread({}, sx.propTypes), COMMON.propTypes), BORDER.propTypes);
Header.defaultProps = {
  theme: theme
};
HeaderItem.propTypes = _objectSpread(_objectSpread(_objectSpread({
  full: PropTypes.bool
}, COMMON.propTypes), BORDER.propTypes), sx.propTypes);
HeaderItem.defaultProps = {
  theme: theme
};
HeaderLink.propTypes = _objectSpread(_objectSpread(_objectSpread(_objectSpread({
  href: PropTypes.string,
  theme: PropTypes.object
}, COMMON.propTypes), BORDER.propTypes), TYPOGRAPHY.propTypes), sx.propTypes);
HeaderLink.defaultProps = {
  theme: theme
};
export default Object.assign(Header, {
  Link: HeaderLink,
  Item: HeaderItem
});